module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodrain@3-62698b08b1f0d8bdae2659974e7cd2ed.png";